<template>
  <van-pull-refresh v-model="refreshing" @refresh="onRefresh" class="interactive_container">
    <van-list v-model="loading" :offset="10" :immediate-check="false" :finished="finished" :finished-text="finishedText" @load="onLoadMore">
      <ul class="interactive_list" v-if="!!guestReviewList && guestReviewList.length > 0">
        <li class="item" v-for="item in guestReviewList" :key="item.id">
          <div class="interactive_title">
            <div class="portrait" :style="{
                backgroundImage:
                  'url(' +
                  (item.guestImgUrl == ''
                    ? require('@/assets/images/user_default.png')
                    : item.guestImgUrl) +
                  ')',
              }"></div>
            <div class="text">
              <span class="nick" v-text="item.guestName"></span>
              <span class="role" v-text="item.roleName"></span>
              <span class="time" v-text="item.createTime"></span>
            </div>
          </div>
          <div class="interactive_content">
            <div class="interactive_cont" v-html="item.text"></div>
          </div>
          <div class="interactive_imgs" v-if="!!item.pictureList && item.pictureList.length>0">
            <van-row class="imgs_list">
              <van-col span="8" v-for="(pic, i) in item.pictureList" :key="i">
                <div class="img_item">
                  <div class="img_item_box">
                    <img v-if="pic.url.length > 0" :src="pic.url" alt="" :onerror="imgLoadError(item)" />
                  </div>
                </div>
                <div></div>
              </van-col>
            </van-row>
          </div>
          <div class="interactive_video" v-if="!!item.videoUrl && item.videoUrl.length>0">
            <div class="video_player">
              <video controls controlslist="nodownload" disablepictureinpicture :src="item.videoUrl" :poster="item.videoPictureUrl"></video>
            </div>
          </div>
        </li>
      </ul>
    </van-list>
  </van-pull-refresh>
</template>
<script>
import liveApi from "@/api/apis/live.js";
export default {
  name: "Comment",
  props: {
    liveRoomId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      refreshing: false,
      loading: false,
      finished: false,
      finishedText: "",
      params: {
        liveroomid: null,
        pageSize: 10,
        pageNo: 0,
        important: true,
      },
      guestReviewList: [], // 图文互动列表
      total: 0,
      pageCount: 0,
      loadFirstPage: true, //是否加载第一页,用来解决vant上拉加载本身的缺陷问题
    };
  },
  watch: {
    liveRoomId: {
      handler(newValue, oldVue) {
        if (!!newValue) this.params.liveroomid = newValue;
        this.params.pageNo = 0;
        this.getListGuestReview();
      },
    },
  },
  methods: {
    imgLoadError(item) {
      // console.log("加载默认图片");
    },
    /* 获取直播间图文互动 */
    getListGuestReview() {
      var _this = this;
      liveApi
        .getListGuestReviewById(_this.params)
        .then((res) => {
          _this.refreshing = false;
          _this.loading = false;
          if (res.suc == 1) {
            if (_this.params.pageNo == 0) {
              _this.guestReviewList = res.data.list;
            } else {
              _this.guestReviewList = _this.guestReviewList.concat(
                res.data.list
              );
            }
            _this.total = res.data.total;

            _this.finishedText = _this.total > 0 ? "没有更多了" : "暂无数据";

            _this.pageCount = Math.ceil(res.data.total / _this.params.pageSize);
            if (_this.params.pageNo >= _this.pageCount - 1) {
              _this.finished = true;
            }
            _this.loadFirstPage = false;
          } else {
            _this.$toast({
              message: res.message || res.text,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 下拉刷新 */
    onRefresh() {
      this.params.pageNo = 0;
      this.total = 0;
      this.pageCount = 0;
      this.loadFirstPage = true;
      if (this.finished) {
        this.refreshing = false;
      } else {
        this.refreshing = true;
      }
      this.loading = false;
      this.finished = false;
      this.getListGuestReview();
    },
    /* 上拉加载 */
    onLoadMore() {
      if (!this.loadFirstPage) {
        this.params.pageNo++;
        if (this.params.pageNo < this.pageCount) {
          this.loading = true;
          this.getListGuestReview();
        }
      }
    },
  },
  mounted() {
    if (!!this.liveRoomId) {
      this.params.liveroomid = this.liveRoomId;
      this.params.pageNo = 0;
      this.getListGuestReview();
    }
  },
};
</script>
<style lang='scss' scoped>
.interactive_container {
  width: 100%;
  height: 100%;
  padding: 10px 15px;
  overflow-x: hidden;
  overflow-y: auto;
  .interactive_list {
    .item {
      padding: 15px 0 10px;
      border-bottom: 1px solid #efefef;
      &:last-child {
        border-bottom: none;
      }
      .interactive_title {
        display: flex;
        .portrait {
          max-width: 32px;
          min-width: 32px;
          height: 32px;
          border: 1px solid #fff;
          border-radius: 16px;
          -webkit-border-radius: 16px;
          -moz-border-radius: 16px;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
        }
        .text {
          width: 100%;
          padding: 0 8px;
          line-height: 32px;
          overflow: hidden;
          .nick {
            color: #1a1a1a;
            font-size: 16px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            line-height: 16px;
          }
          .role {
            margin-left: 5px;
            padding: 2px 5px;
            background: #d50d2a;
            color: #fff;
            font-size: 12px;
            border-radius: 8px;
            vertical-align: top;
          }
          .time {
            float: right;
            color: #a1a1a1;
            font-size: 10px;
            line-height: 20px;
            margin-top: 3px;
          }
        }
      }
      .interactive_content {
        line-height: 24px;
        margin-top: 5px;
        color: #1a1a1a;
        .interactive_cont {
          padding-bottom: 5px;
          text-align: justify;
        }
      }
      .interactive_imgs {
        .imgs_list {
          margin-bottom: 8px;
          .img_item {
            position: relative;
            height: 0;
            padding-bottom: 56.25%;
            margin-left: 2.4px;
            margin-right: 2.4px;
            overflow: hidden;
            .img_item_box {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              height: 100%;
              background-image: url(~@/assets/images/default_pic_16_9.png);
              background-size: cover;
              background-repeat: no-repeat;
              background-position: center;
              display: flex;
              justify-content: center;
              img {
                object-fit: cover;
                min-width: 100%;
                min-height: 100%;
              }
            }
          }
        }
      }
      .interactive_video {
        .video_player {
          width: 100%;
          video {
            display: block;
            width: 100%;
          }
        }
      }
    }
  }
}
</style>